var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2559800_location_media_network_social_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0.666687C9.46667 0.666687 4 6.13335 4 12.8C4 21.4667 13.0667 31.3334 16 31.3334C18.9333 31.3334 28 21.4667 28 12.8C28 6.13335 22.5333 0.666687 16 0.666687ZM16 20.4C11.8667 20.4 8.53333 16.9334 8.53333 12.8C8.53333 11.2 9.06667 9.60002 10 8.40002C10.1333 8.13335 10.4 8.00002 10.6667 8.13335C10.9333 8.26669 11.0667 8.40002 11.0667 8.66669C11.2 9.86669 12.1333 10.6667 13.2 10.6667C14.4 10.6667 15.3333 9.73335 15.3333 8.53335C15.3333 7.73335 14.9333 6.93335 14.1333 6.53335C13.8667 6.40002 13.7333 6.13335 13.7333 5.86669C13.7333 5.60002 14 5.33335 14.2667 5.33335C14.8 5.33335 15.4667 5.20002 16 5.20002C20.1333 5.20002 23.4667 8.66669 23.4667 12.8C23.4667 17.0667 20.1333 20.4 16 20.4Z",
    fill: "#163E6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLocation);
export default __webpack_public_path__ + "static/media/landing_location.f66d34dff60e6a3cdd97639b3a9ebb8c.svg";
export { ForwardRef as ReactComponent };